import { ArtifactsProps } from "../../shared/interfaces/components/history-artifacts/historyArtifacts.interface";
import * as types from "./consts";

export const getArtifactsRequest = (payload: ArtifactsProps) => ({
  type: types.GET_ARTIFACTS_REQUEST,
  payload,
});
export function postArtifactsSaga(payload: { conversation_id: string; }): any {
  throw new Error("Function not implemented.");
}

